var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 19V17.3333C18.3333 16.4493 17.9821 15.6014 17.357 14.9763C16.7319 14.3512 15.8841 14 15 14H8.33333C7.44928 14 6.60143 14.3512 5.97631 14.9763C5.35119 15.6014 5 16.4493 5 17.3333V19",
    fill: "#0A80D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 19V17.3333C18.3333 16.4493 17.9821 15.6014 17.357 14.9763C16.7319 14.3512 15.8841 14 15 14H8.33333C7.44928 14 6.60143 14.3512 5.97631 14.9763C5.35119 15.6014 5 16.4493 5 17.3333V19",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 10.6667C13.5083 10.6667 15.0007 9.17428 15.0007 7.33333C15.0007 5.49238 13.5083 4 11.6673 4C9.82637 4 8.33398 5.49238 8.33398 7.33333C8.33398 9.17428 9.82637 10.6667 11.6673 10.6667Z",
    fill: "#0A80D5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedUser);
export default __webpack_public_path__ + "static/media/selected-user.ddda92d732b04d4c75a454f2520b12a5.svg";
export { ForwardRef as ReactComponent };